import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import useHasIntersected from 'core/hooks/useHasIntersected';

export default function LoadingInView({ delay = 200 }: { delay?: number }) {
    const ref = React.useRef<HTMLDivElement>(null);
    const hasIntersected = useHasIntersected(ref, { rootMargin: '200px' });
    const [show, setShow] = React.useState(false);

    React.useEffect(() => {
        if (hasIntersected) {
            const t = setTimeout(() => setShow(true), delay);
            return () => clearTimeout(t);
        }
        return undefined;
    }, [hasIntersected, delay]);

    return (
        <div ref={ref} className="spinner-wrap" aria-label="Loading">
            {show ? (
                <CircularProgress size={20} thickness={4} disableShrink />
            ) : null}
        </div>
    );
}
